package com.alpha.showcase.common.repo

import com.alpha.showcase.common.networkfile.storage.remote.RemoteApi

internal actual fun defaultRemoteSources(): MutableList<RemoteApi> = mutableListOf()
